import {pushEdapEvent} from './../../utils/edap';

export const ACTION_LOCATION = 'dynamic-refinements-component';
export const EVENT_CATEGORY = 'link-click';

export const handleClick = (props) => {
    const {lbsId, position, filterId} = props;

    const eventrefinements = [`position:${position}`, `filter:${filterId}`];

    const eventData = {
        actionlocation: ACTION_LOCATION,
        eventlbsuuid: lbsId,
        eventcategory: EVENT_CATEGORY,
        eventrefinements: eventrefinements.join(','),
    };

    const fastPathEventOptions = {
        action_location: ACTION_LOCATION,
        event_lbsuuid: lbsId,
        event_category: EVENT_CATEGORY,
        event_refinements: eventrefinements.join(','),
    };

    return () => {
        pushEdapEvent('destination.link.click', eventData);
        pushEdapEvent('content_tile.selected', fastPathEventOptions);
    };
};
